import { Box } from '@mantine/core';

import { DesktopNav } from './desktop-nav/desktop-nav';
import { MobileNav } from './mobile-nav/mobile-nav';
import classes from './navigation.module.css';
import { SportybotLogo } from './sportybot-logo/sportybot-logo';

export function Navigation() {
  return (
    <Box className={classes.container}>
      <SportybotLogo />
      <DesktopNav />
      <MobileNav />
    </Box>
  );
}
